import { HvacResultsRating } from '@belimo-retrofit-portal/logic';
import { createSelector } from 'reselect';
import { getHvacResults } from 'src/modules/hvac/selectors/getHvacResults';

export const getHvacResultsOverallRating = createSelector([
  getHvacResults,
], (results): HvacResultsRating => results.overall.rating);
